export default __webpack_public_path__ + "static/media/image-about-mission-w.4b86a8d8.webp";